module.exports = __webpack_public_path__ + "static/media/skills.834cf215.svg";